// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ILegalStatusType {
    id: number;
    code: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class LegalStatusType implements ILegalStatusType, IBaseType {
    public id: number;
    public code: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns And LegalStatusType
	**/
    get And(): ILegalStatusType {
        return this.FromId(1);
    }
    /**
		Returns And/Or LegalStatusType
	**/
    get AndOr(): ILegalStatusType {
        return this.FromId(2);
    }
    /**
		Returns Or LegalStatusType
	**/
    get Or(): ILegalStatusType {
        return this.FromId(9);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, code: 'And', displayValue: 'And', description: '\'And\' signifies tenancy in common', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, code: 'And/Or', displayValue: 'And/Or', description: '“And/Or” signifies joint tenancy with the right of survivorship', sortOrder: 999999, active: true });
        this._dictionary.add('9', { id: 9, code: 'Or', displayValue: 'Or', description: '“Or” signifies a joint tenancy.', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ILegalStatusType {
        return this._dictionary[id];
    }

    public FromCode(code: string): ILegalStatusType {
        var match = this._dictionary.getValues().filter(d => d.value == code);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ILegalStatusType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ILegalStatusType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ILegalStatusType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
